import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DiagnosticProfilePreferenceService {
  // Browser-scoped preference: shared across users on the same device.
  // Stale state across logout/login is mitigated at the buffer level —
  // DiagnosticBufferService.clear() is invoked on UserService.currentUser
  // null emission and also calls preference.clear() (see EAS-2040 review).
  private static readonly STORAGE_KEY = 'easylot.diagnostic.activeProfile';

  read(): string | null {
    try {
      return localStorage.getItem(
        DiagnosticProfilePreferenceService.STORAGE_KEY
      );
    } catch {
      return null;
    }
  }

  write(profileName: string): void {
    try {
      localStorage.setItem(
        DiagnosticProfilePreferenceService.STORAGE_KEY,
        profileName
      );
    } catch {
      // localStorage may be unavailable (private browsing, quota exceeded,
      // disabled by user). The preference is best-effort: in-memory state
      // remains correct, the user just loses the setting on reload.
    }
  }

  clear(): void {
    try {
      localStorage.removeItem(DiagnosticProfilePreferenceService.STORAGE_KEY);
    } catch {
      // Same silent fallback as write().
    }
  }
}
